import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import Footer from 'components/footer/Footer';
import ProductProvider from 'providers/ProductProvider';
import CourseProvider from 'providers/CourseProvider';
import ModalAuth from 'components/authentication/modal/ModalAuth';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import { useAppContext } from 'providers/AppProvider';
import HippaPopUp from 'components/authentication/HippaPopUp';
import axios from 'axios';

//import { updateGroupId } from '../components/common/commonutil';

const MainLayout = () => {
  const [showHippa, setShowHippa] = useState(localStorage.getItem('isHippaDone') === '0' ? true : false);
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition }
  } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);

  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  /*useEffect(() => {
    updateGroupId();
  }, []);*/

  const handleHippaAccept = async () => {
    const tokenStr = localStorage.getItem('accessToken');
    const userProfileUrl = `${process.env.REACT_APP_SERVER_URL}/users/update`;
    const userProfileData = {
      user_id: localStorage.getItem("userId"),
      is_hippa_done: 1
    }
    const { data } = await axios.post(userProfileUrl, userProfileData, {
      headers: { Authorization: `Bearer ${tokenStr}` }
    });
    if (data.status) {
      setShowHippa(false);
      localStorage.removeItem('isHippaDone');
      localStorage.removeItem('useId');
    }
  }

  return (

    <div className={isFluid ? 'container-fluid' : 'container'}>
      <HippaPopUp show={showHippa} onAccept={handleHippaAccept} />
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <ProductProvider>
        <CourseProvider>
          <div className={classNames('content', { 'pb-0': isKanban })}>
            <NavbarTop />
            {/*------ Main Routes ------*/}
            {/* <Breadcrumb>
              <Breadcrumb.Item href="#">Main</Breadcrumb.Item>
              <Breadcrumb.Item href="https://getbootstrap.com/docs/4.0/components/breadcrumb/">
                Patient
              </Breadcrumb.Item>
            </Breadcrumb> */}
            <Outlet />
            {!isKanban && <Footer />}
          </div>
        </CourseProvider>
      </ProductProvider>
      <ModalAuth />
    </div>
  );
};

export default MainLayout;
